import { GetStaticProps, InferGetStaticPropsType } from "next";
import { ParsedUrlQuery } from "querystring";

import { Spacing, call, NextLink } from "goi_common";

import DefaultPageLayout from "@/components/DefaultPageLayout";
import NonBorderTable from "@/components/table/NonBorderTable";
import OutlinedButton from "@/components/button/OutlinedButton";

import ParlorClosedInformation from "@/containers/ParlorClosedContainer/components/ParlorClosedInformation";
import { ClosedSangjoMenuTabs } from "@/containers/ParlorClosedContainer/components/ClosedSangjoMenuTabs";

import CLOSED_SANGJO_LIST from "@/constants/closed_sangjo.json";

interface Params extends ParsedUrlQuery {
  id: string;
}

export const getStaticPaths = async () => {
  const paths = CLOSED_SANGJO_LIST.map((closedSangjo) => {
    return {
      params: {
        id: String(closedSangjo.id),
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { id } = params as Params;

  const closedSangjoData = CLOSED_SANGJO_LIST.find(
    (closedSangjo) => closedSangjo.id === Number(id),
  );

  const companyName = closedSangjoData?.companyname || "";

  const title = `${companyName} 상조 안내 - [상조 상품 비교 사이트, 헤이상조]`;
  const description = `${companyName} 상조를 소개해드립니다. ${companyName}의 영업 상태부터 ${companyName} 선수금 보전기관까지 안내해드립니다.`;
  const keywords = `${companyName}, ${companyName} 영업 상태, ${companyName} 폐업, ${companyName} 상조 폐업, ${companyName} 상조, ${companyName} 내상조그대로, ${companyName} 상조 상담`;

  return {
    props: {
      closedSangjoData,
      pageDescription: description,
      pageOgTitle: title,
      pageOgDescription: description,
      pageKeywords: keywords,
      pageOgImage: "",
    },
  };
};

const ClosedSangjoGuidePage = ({
  closedSangjoData,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { id, companyname, openDate, closeDate, depositAgency, status } = closedSangjoData;

  const closedSangjoRows = [
    { key: "회사명", value: companyname },
    { key: "영업개시일", value: openDate },
    { key: "폐업/등록취소일", value: closeDate },
    { key: "선수금 보전기관", value: depositAgency },
  ];

  return (
    <DefaultPageLayout title={companyname}>
      <Spacing gap={35} />
      <ClosedSangjoMenuTabs />

      <Spacing gap={45} />
      <ParlorClosedInformation companyName={companyname} status={status} />

      <Spacing gap={35} />
      <NonBorderTable rows={closedSangjoRows} />

      <Spacing gap={35} />
      <NextLink
        href={`https://prime.goifuneral.co.kr/closed/${id}/`}
        event={{
          domain: "heysangjo",
          path: "closed",
          trigger_and_target: "uv_clsd_detail",
        }}
      >
        <OutlinedButton className="subtitle_18_b" size="medium" fullWidth>
          폐업 상조 도움받기
        </OutlinedButton>
      </NextLink>
    </DefaultPageLayout>
  );
};

export default ClosedSangjoGuidePage;
